import React from 'react';
import { useSnackbar } from 'notistack';
import * as S from './styled';
import Icons from '../Icons';

const VARIANT_TITLE_MAP = {
  success: 'SUCCESS',
  error: 'ERROR',
  warning: 'WARNING',
  info: 'INFO'
};

const VARIANT_ICON_MAP = {
  success: Icons.SnackbarSuccess,
  error: Icons.SnackbarError,
  warning: Icons.SnackbarWarning,
  info: Icons.SnackbarInfo
};

const CustomSnackbar = React.forwardRef((props, ref) => {
  const {
    id,
    title: _title,
    message,
    icon,
    color,
    variant = 'info',
    link,
    onLinkClick,
    withCloseAction = true,
    style,
    className,
    ...other
  } = props;

  const { closeSnackbar } = useSnackbar();

  const handleClose = () => {
    if (id !== undefined) {
      closeSnackbar(id);
    }
  };

  const VariantIcon = VARIANT_ICON_MAP[variant] ?? Icons.SnackbarInfo;
  const title = _title === true || _title === undefined ? VARIANT_TITLE_MAP[variant] ?? 'INFO' : _title;

  return (
    <S.SnackbarCard ref={ref} style={style} className={className} $variant={variant} $color={color} {...other}>
      <S.SnackbarInner>
        <div className="variant-icon">{icon || <VariantIcon size={32} />}</div>

        <S.SnackbarText>
          {!!title && <S.SnackbarTitle>{title}</S.SnackbarTitle>}
          <S.SnackbarMessage>{message}</S.SnackbarMessage>
          {typeof link === 'string' ? <S.SnackbarLink onClick={onLinkClick}>{link}</S.SnackbarLink> : link}
        </S.SnackbarText>

        {withCloseAction && (
          <S.SnackbarClose onClick={handleClose} aria-label="Close" data-testid="snackbar-close-button">
            <Icons.SnackbarClose fontSize="10px" />
          </S.SnackbarClose>
        )}
      </S.SnackbarInner>
    </S.SnackbarCard>
  );
});

CustomSnackbar.displayName = 'CustomSnackbar';

export default CustomSnackbar;
